import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/init-console/')({
	component: InitConsolePage,
});

function InitConsolePage() {
	return (
		<div className="space-y-2">
			<h1 className="text-lg font-semibold">Init console</h1>
			<div className="text-neutral-gray-600">
				{Array.from({ length: 300 }, (_, i) => i + 1).map((n) => (
					<p key={n} className="h-4 bg-neutral-gray-200">
						{n}
					</p>
				))}
			</div>
		</div>
	);
}
